/**
 * Gated-resource (lead magnet) configuration.
 *
 * SCAFFOLDED, NOT PUBLISHED. The two campaign PDFs and the lead-form backend
 * are deferred. While RESOURCES_ENABLED is false:
 *   - the resource landing pages render a "coming soon" scaffold (no live
 *     form submission);
 *   - the IT page's "Download the checklist" CTA is hidden;
 *   - the routes are marked noindex and kept out of the sitemap
 *     (see scripts/og-route-manifest.js).
 *
 * To launch: drop the real PDFs at the download paths, set LOOPS_LEAD_FORM_URL
 * to the real Loops form, flip RESOURCES_ENABLED to true, and remove the
 * noindex flags from the manifest. See LAUNCH_CHECKLIST.md.
 */

export const RESOURCES_ENABLED = false;

/**
 * Lead form endpoint. The site's existing pattern POSTs urlencoded form data
 * to a Loops newsletter form (see LandingPage.tsx). app.loops.so is already
 * allowlisted in the CSP connect-src.
 *
 * TODO(resources): replace with the real Loops lead-capture form URL before
 * enabling. Empty string keeps the scaffold inert even if the flag is flipped
 * by mistake.
 */
export const LOOPS_LEAD_FORM_URL = "";

export interface ResourceAsset {
  /** GA4 lead_submit `asset` value. */
  id: "agency_playbook" | "it_checklist";
  slug: string;
  routePath: string;
  thankYouPath: string;
  title: string;
  /** One-line value prop shown on the landing page. */
  summary: string;
  /** TODO: replace with provided PDF. */
  downloadUrl: string;
}

export const RESOURCE_ASSETS: Record<ResourceAsset["id"], ResourceAsset> = {
  agency_playbook: {
    id: "agency_playbook",
    slug: "jotform-agency-form-safety-playbook",
    routePath: "/resources/jotform-agency-form-safety-playbook",
    thankYouPath: "/resources/jotform-agency-form-safety-playbook/thank-you",
    title: "The Jotform Agency Form Safety Playbook",
    summary:
      "A practical guide for agencies that build and maintain Jotform forms for clients.",
    // TODO: replace with provided PDF
    downloadUrl: "/downloads/placeholder.pdf",
  },
  it_checklist: {
    id: "it_checklist",
    slug: "it-saas-backup-checklist",
    routePath: "/resources/it-saas-backup-checklist",
    thankYouPath: "/resources/it-saas-backup-checklist/thank-you",
    title: "The IT SaaS Backup Checklist",
    summary:
      "A checklist for bringing form-builder SaaS like Jotform under your backup policy.",
    // TODO: replace with provided PDF
    downloadUrl: "/downloads/placeholder.pdf",
  },
};
